import { useGetPostTypeFeature } from '@/features/post-editor/hooks/useGetPostFeature';
import { PostFeedType } from '@/features/posts/types/postFeed';

/**
 * Geo-area configurable label of the Gossip channel ("Plausch", "Ratsch", ...),
 * resolved the same way as in the post editor (backend Gossip feature values).
 */
export const useGossipChannelLabel = (): string =>
  useGetPostTypeFeature(PostFeedType.GOSSIP).channelName;
